import { getCurrentUser } from "aws-amplify/auth";

const logUserActivity = async (action, details = {}) => {
  try {
    const user = await getCurrentUser();

    await fetch("https://nodei.ssccglpinnacle.com/log-activity", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: user.userId,
        email: user.signInDetails?.loginId || "N/A",
        name: user?.signInDetails?.loginId?.split("@")[0] || "Unknown",
        action,
        details,
      }),
    });
  } catch (error) {
    console.error("Error logging user activity:", error);
  }
};

export default logUserActivity;